module.exports = __webpack_public_path__ + "static/media/css.1546a15f.svg";